export default "__VITE_ASSET__DOONYCuk__"